import { Document, Page, View, Text, Image, StyleSheet } from '@react-pdf/renderer';
import {Font} from '@react-pdf/renderer';

Font.register({
    family: 'Roboto',
    fonts: [
      {
        src: 'https://fonts.gstatic.com/s/roboto/v30/KFOkCnqEu92Fr1MmgVxFIzIFKw.woff2',
        fontWeight: 100,
      },
      {
        src: 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmSU5fCRc4EsA.woff2',
        fontWeight: 300,
      },
      {
        src: 'https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu72xKOzY.woff2',
        fontWeight: 400,
      },
      {
        src: 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmEU9fCRc4EsA.woff2',
        fontWeight: 500,
      },

      {
        src: 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmWUlfCRc4EsA.woff2',
        fontWeight: 700,
      },
      {
        src: 'https://fonts.gstatic.com/s/roboto/v30/KFOlCnqEu92Fr1MmYUtfCRc4EsA.woff2',
        fontWeight: 900,
      },
    ],
  });

function InvoicePreview({ invoiceData }: { invoiceData: any }) {

    return (
        <Document>
            <Page style={styles.page}>
                <View wrap={true}>
                    <View style={{ padding: 20,marginTop:25}}>
                        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                            <View style={{ width: '48%' }}>
                                <Image src="/images/logopdf.png" style={styles.logo} />
                                <View style={{ marginTop: 16 }}>
                                    <Text style={{ fontSize: 13, fontWeight: 'bold',fontFamily:'Roboto' }}>Syscom Entertainment & Leisure Limited</Text>
                                    <Text style={{fontSize:12,fontFamily:'Roboto'}}>
                                        Suite 312, Atlas House,
                                    </Text>
                                    <Text style={{fontSize:12,fontFamily:'Roboto'}}>
                                        Caxton Close, Wigan
                                    </Text>
                                    <Text style={{fontSize:12,fontFamily:'Roboto'}}>
                                        WN3 6XU, United Kingdom<br />
                                    </Text>
                                </View>
                            </View>
                            <View style={{ width: '48%', textAlign: 'right',justifyContent:'flex-end',alignItems:'flex-end' }}>
                                <View style={{display:'flex',justifyContent:'flex-end',marginBottom:10}}>
                                    <Image src="/images/paid.jpg" style={styles.seal} />
                                </View>
                                <Text style={{ marginBottom: 0, paddingBottom: 0 }}><Text style={{ fontWeight: 'bold',fontSize:12 }}>Invoice No. {invoiceData?.number}</Text></Text>
                                <Text style={{ marginBottom: 0, paddingBottom: 0,fontSize:12 }}>Created: {invoiceData?.created_at}</Text>
                                <Text style={{fontSize:12}}>Due: {invoiceData?.due_at}</Text>
                                <View style={{ marginTop: 16,justifyContent:'flex-end',alignItems:'flex-end' }}>
                                    <Text style={{ fontWeight: 'bold',fontSize:14 }}>{invoiceData?.username}</Text>
                                    <Text style={{ fontSize:12 }}>
                                        {invoiceData?.owner_name}<br />
                                    </Text>
                                    <Text style={{ fontSize:12 }}>
                                        {invoiceData?.city}, {invoiceData?.state}<br />
                                    </Text>
                                    <Text style={{ fontSize:12 }}>
                                        {invoiceData?.country}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View style={{ marginTop: 24 }}>
                            <View style={{ marginTop: 24 }}>
                                {/* Table Header */}
                                <View style={{ flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#000', paddingBottom: 5,width:"100%" }}>
                                    <Text style={[styles.cell, { flex: 2, fontWeight: 'bold',fontSize:10,width:'30%',height:20 }]} wrap={false}>LICENSE</Text>
                                    <Text style={[styles.cell, { flex: 1, fontWeight: 'bold',fontSize:10,width:'20%',height:20 }]} wrap={false}>COST</Text>
                                    <Text style={[styles.cell, { flex: 1, fontWeight: 'bold',fontSize:10,width:'20%',height:20 }]} wrap={false}>QUANTITY</Text>
                                    <Text style={[styles.cell, { flex: 1, textAlign: 'right', fontWeight: 'bold',fontSize:10,alignSelf:'flex-end',width:'30%',height:20 }]} wrap={false}>AMOUNT</Text>
                                </View>

                                {/* Table Rows */}
                                {invoiceData?.packages?.map((p:any) => (
                                    <View key={'invoice_cell_'+p?.id} style={{ flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#ccc', paddingVertical: 5,width:"100%",height:35, alignItems:'center',justifyContent:'center' }}>
                                        <Text style={[styles.cell, { flex: 2,fontSize:13,width:'30%' }]} wrap={false}>{p?.name}</Text>
                                        <Text style={[styles.cell, { flex: 1,fontSize:13,width:'30%' }]} wrap={false}>£{p?.price}</Text>
                                        <Text style={[styles.cell, { flex: 1,fontSize:13 ,width:'30%'}]} wrap={false}>{p?.qty}</Text>
                                        <Text style={[styles.cell, { flex: 1, textAlign: 'right',fontSize:13,width:'30%' }]} wrap={false}>£{p?.total}</Text>
                                    </View>
                                ))}
                            </View>
                        </View>
                        <View style={{ marginTop: 16, textAlign:'right',justifyContent:'flex-end',alignItems:'flex-end' }}>
                            <Text style={{fontSize:12,marginBottom:3,fontWeight:'normal'}}>Total Amount: £{invoiceData?.amount}</Text>
                            <Text style={{fontSize:12,marginBottom:3,fontWeight:'normal'}}>Discount: £{invoiceData?.discount}</Text>
                            <Text style={{ fontSize: 14, fontWeight:'bold' }}>Order Value: £{invoiceData?.total}</Text>
                            <Text><Text style={{ fontSize: 10 }}>(Taxes/charges applied separately)</Text></Text>
                        </View>
                        <View style={{ marginTop: 40 }}>
                            <Text style={{ fontSize: 8 }}>Note: The license key/s purchased and activated through this order is/are valid for a two-year subscription of cloud storage with applied T&C.</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
}

const styles = StyleSheet.create({
    page: {
        flexDirection: 'row',
        backgroundColor: '#fff'
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    logo: {
        width: 160
    },
    seal: {
        width: 50
    },
    cell: { fontSize: 10 },
    title:{
        fontFamily: 'Roboto'
    }

});

export default InvoicePreview;
